export default class MapboxService {
	static transformRequest(url, resourceType) {
		let result = url;

		if (resourceType === 'Tile' && url.indexOf('/maps-source/data/v3/') !== -1) {
			result = location.origin + url;
		} else if ((resourceType === 'SpriteJSON' || resourceType === 'SpriteImage') && url.indexOf('/maps-source/mapboxgl/sprite') !== -1) {
			result = url.replace('https://', location.origin + '/');
		}

		return { url: result };
	}
}
